// import { LanguageService } from '../../../core/services/language/language.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
// import { TranslatePipe } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
	selector: 'app-access-denied',
	imports: [
		ReactiveFormsModule,
		// TranslatePipe,
		FormsModule
	],
	templateUrl: './access-denied.component.html',
	styleUrl: './access-denied.component.scss',
})

export class AccessDeniedComponent {

	constructor(
		private authSvc: AuthService,
		// private _languageService: LanguageService
	) {	}

	public login(): void {
		this.authSvc.logout();
	}

}